import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class NumericSlider extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    // let initMin = this.props.initMinValue;
    // if(!initMin) {
    //   initMin = this.props.minValue;
    // }
    
    // let initMax = this.props.initMaxValue;
    // if(!initMax) {
    //   initMax = this.props.maxValue;
    // }

		this.state = {
      
      scaleType: this.props.scale,
      numberFormat: this.props.format,

      cursorLeftPos: this.logPosFromValue(this.props.initMinValue),
      cursorRightPos: this.logPosFromValue(this.props.initMaxValue),

      // minValue: this.props.minValue,
      // maxValue: this.props.maxValue,

      currentMin: this.props.initMinValue,
      currentMax: this.props.initMaxValue,

      dragActive: false,
      dragElement: null,

      dragStartTime: 0,
      checkDelay: 3000,
      lastMinValue: null,
      lastMaxValue: null,

    };

    // Bind event listeners
    this.dragStartLeft = ::this.dragStartLeft;
    this.dragStartRight = ::this.dragStartRight;
    this.dragEndAll = ::this.dragEndAll;
    this.moveSlider = ::this.moveSlider;

    this.checkMovement = ::this.checkMovement;
	}

	componentDidMount() {
    this.addClickHandlers(0);
    let checkId = setInterval(this.checkMovement, 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.resetElement != prevProps.resetElement) {
      this.resetData();
    }
  }

  checkMovement() {
    if(this.state.dragActive) {

      if(this.state.currentMin == this.state.lastMinValue && this.state.currentMax == this.state.lastMaxValue && (Date.now() - this.state.dragStartTime) > this.state.checkDelay) {
        this.dragEndAll();  
      } else {
        this.setState({
          lastMinValue: this.state.currentMin,
          lastMaxValue: this.state.currentMax,
        });
      }
    }
  }

  resetData() {
    this.setState({
      scaleType: this.props.scale,
      numberFormat: this.props.format,

      cursorLeftPos: this.logPosFromValue(this.props.minValue),
      cursorRightPos: this.logPosFromValue(this.props.maxValue),

      // minValue: this.props.minValue,
      // maxValue: this.props.maxValue,

      currentMin: this.props.minValue,
      currentMax: this.props.maxValue,

      dragActive: false,
      dragElement: null,
    });
  }

  addClickHandlers() {
    if(this.leftHandle && this.rightHandle) {

      // Start methods
      this.leftHandle.addEventListener('mousedown', this.dragStartLeft, false);
      this.leftHandle.addEventListener('touchstart', this.dragStartLeft, false);
  
      this.rightHandle.addEventListener('mousedown', this.dragStartRight, false);
      this.rightHandle.addEventListener('touchstart', this.dragStartRight, false);

      // End methods
      window.addEventListener('mouseup', this.dragEndAll, false);
      this.leftHandle.addEventListener('touchend touchcancel', this.dragEndAll, false);

      window.addEventListener('mousemove', this.moveSlider, false);
      this.leftHandle.addEventListener('touchmove', this.moveSlider, false);

      // this.rightHandle.addEventListener('mouseup', this.dragEndAll, false);
      // this.rightHandle.addEventListener('touchend touchcancel', this.dragEndAll, false);

      // this.rightHandle.addEventListener('mousemove', this.moveSlider, false);
      this.rightHandle.addEventListener('touchmove', this.moveSlider, false);


      // window.addEventListener('mouseup', this.dragEndAll, false);
      // window.addEventListener('touchend touchcancel', this.dragEndAll, false);

      // window.addEventListener('mousemove', this.moveSlider, false);
      // window.addEventListener('touchmove', this.moveSlider, false);

    } else {
      setTimeout(() => {
        this.addClickHandlers();
      }, 5);
    }
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  dragStartLeft() {
    this.setState({
      dragActive: true,
      dragStartTime: Date.now(),
      dragElement: 'left',
    });
  }

  dragStartRight() {
    this.setState({
      dragActive: true,
      dragStartTime: Date.now(),
      dragElement: 'right',
    });
  }

  dragEndAll() {

    if(this.state.dragActive) {

      console.log(this.props.service);
      console.log([this.props.minKey, this.props.maxKey]);
      console.log([this.state.currentMin, this.state.currentMax]);

      this.props.refreshData(this.props.service, [this.props.minKey, this.props.maxKey], [this.state.currentMin, this.state.currentMax]);
      this.setState({
        dragActive: false,
        dragElement: null,
      });
    }
  }

  clickContained(evt) {

    if(this.state.dragActive) {

      let targetElement = evt.target;
      do {
        if (targetElement == this.rootObject) {
            return true;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside, should let go 
      return false;
    }
  }

  moveSlider(evt) {

    if(this.props.disabled) {
      return;
    }

    if(this.state.dragActive) {

      if(this.clickContained(evt) === false) {
        this.dragEndAll();
        return;
      }

      let rootElem = this.rootObject.getBoundingClientRect();
      let rootLeft = rootElem.left;
      let rootRight = rootElem.right;

      let leftPercent = this.state.cursorLeftPos;
      let rightPercent = this.state.cursorRightPos;

      if(this.state.dragElement == 'left') {
        
        let clientX = 0;
        if(evt.touches) {
          clientX = evt.touches[0].clientX;
        } else {
          clientX = evt.clientX;
        }
        let leftLength = clientX - rootLeft;

        if(leftLength < 0) {
          let leftLength = 0.00;
        } else {

          leftPercent = leftLength / (rootRight - rootLeft);
          if(leftPercent > rightPercent) {
            leftPercent = rightPercent;
          }
        }
      }

      if(this.state.dragElement == 'right') {

        let clientX = 0;
        if(evt.touches) {
          clientX = evt.touches[0].clientX;
        } else {
          clientX = evt.clientX;
        }
        let rightLength = rootRight - clientX;

        if(rightLength < 0) {
          let rightLength = 1.00;
        } else {

          rightPercent = 1 - rightLength / (rootRight - rootLeft);
          if(rightPercent < leftPercent) {
            rightPercent = leftPercent;
          }
        }
      }

      let curMin = null;
      let curMax = null;
      let valueRange = this.props.maxValue - this.props.minValue;

      
      if(this.state.scaleType == 'log') {

        if(this.state.numberFormat == 'currency') {
          curMin = Math.round(this.logslider(leftPercent));
          curMax = Math.round(this.logslider(rightPercent));
        } else {
          curMin = Math.round(this.logslider(leftPercent) * 100) / 100;
          curMax = Math.round(this.logslider(rightPercent) * 100) / 100;
        }
      } else {
        curMin = Math.round(leftPercent * valueRange + this.props.minValue);
        curMax = Math.round(rightPercent * valueRange + this.props.minValue);
      }

      this.setState({
        cursorLeftPos: leftPercent,
        cursorRightPos: rightPercent,
        currentMin: curMin,
        currentMax: curMax,
      })
    }
  }

  logslider(position) {
    
    let minValue = this.props.minValue;
    let maxValue = this.props.maxValue;

    if(minValue == 0) {
      if(position == 0) {
        return 0;
      }
      minValue = minValue + 1;
    }

    let pos = position * 100;

    // pos will be between 0 and 100
    let minp = 0;
    let maxp = 100;

    // The result should be between 100 an 10000000
    let minv = Math.log(minValue);
    let maxv = Math.log(maxValue);

    // calculate adjustment factor
    let scale = (maxv - minv) / (maxp - minp);

    return Math.exp(minv + scale * (pos - minp));
  }

  logPosFromValue(val) {

    let minValue = this.props.minValue;
    let maxValue = this.props.maxValue;

    if(minValue == 0) {
      if(val == 0) {
        return 0;
      }
      minValue = minValue + 1;
    }

    // pos will be between 0 and 100
    let minp = 0;
    let maxp = 100;

    // The result should be between 100 an 10000000
    let minv = Math.log(minValue);
    let maxv = Math.log(maxValue);

    // calculate adjustment factor
    let scale = (maxv - minv) / (maxp - minp);

    return ( ((Math.log(val) - minv) / scale) + minp) / 100;
  }

  linearPosFromValue(val) {

    let minValue = this.props.minValue;
    let maxValue = this.props.maxValue;

    if(minValue == 0) {
      if(val == 0) {
        return 0;
      }
      minValue = minValue + 1;
    }

    // console.log(minValue);
    // console.log(maxValue);

    // pos will be between 0 and 100
    let minp = 0;
    let maxp = 100;

    let numerator = val - minValue;
    let denominator = maxValue - minValue;

    return (numerator / denominator);
  }

  getLeftBarInlineStyles() {
    return {
      width: Math.round(this.state.cursorLeftPos * 100) + '%',
    }
  }

  getMiddleBarInlineStyles() {
    return {
      left: Math.round(this.state.cursorLeftPos * 100) + '%',
      right: Math.round((1 - this.state.cursorRightPos) * 100) + '%',
    }
  }

  getRightBarInlineStyles() {
    return {
      width: Math.round((1 - this.state.cursorRightPos) * 100) + '%',
    }
  }

  getLeftDotInlineStyles() {
    return {
      left: Math.round(this.state.cursorLeftPos * 100) + '%',
    }
  }

  getRightDotInlineStyles() {
    return {
      left: Math.round(this.state.cursorRightPos * 100) + '%',
    }
  }

  changeMinValue(evt) {

    let minVal = evt.target.value;

    this.setState({
      currentMin: minVal,
    }, () => {
      if(this.state.scaleType == 'log') {
        this.setState({ cursorLeftPos: this.withinRange(this.logPosFromValue(minVal), 0, this.state.cursorRightPos) });
      } else {
        this.setState({ cursorLeftPos: this.withinRange(this.linearPosFromValue(minVal), 0, this.state.cursorRightPos) });
      }
    });
  }

  changeMaxValue(evt) {

    let maxVal = evt.target.value;

    this.setState({
      currentMax: maxVal,
    }, () => {
      if(this.state.scaleType == 'log') {
        this.setState({ cursorRightPos: this.withinRange(this.logPosFromValue(maxVal), this.state.cursorLeftPos, 1) });
      } else {
        this.setState({ cursorRightPos: this.withinRange(this.linearPosFromValue(maxVal), this.state.cursorLeftPos, 1) });
      }
    });
  }

  checkMinValue() {

    let minVal = parseFloat(this.state.currentMin);

    if(minVal < parseFloat(this.props.minValue)) {
      minVal = parseFloat(this.props.minValue);
    }
    if(minVal > parseFloat(this.state.currentMax)) {
      minVal = parseFloat(this.state.currentMax);
    }

    if(this.props.format == 'currency') {
      minVal = Math.round(minVal);
    }

    this.setState({
      currentMin: minVal,
    }, () => {
      if(this.state.scaleType == 'log') {
        this.setState({ cursorLeftPos: this.withinRange(this.logPosFromValue(minVal), 0, this.state.cursorRightPos) });
      } else {
        this.setState({ cursorLeftPos: this.withinRange(this.linearPosFromValue(minVal), 0, this.state.cursorRightPos) });
      }
      

      this.props.refreshData(this.props.service, [this.props.minKey, this.props.maxKey], [this.state.currentMin, this.state.currentMax]);
    });
  }

  checkMaxValue() {

    let maxVal = parseFloat(this.state.currentMax);

    if(maxVal > parseFloat(this.props.maxValue)) {
      maxVal = parseFloat(this.props.maxValue);
    }
    if(maxVal < parseFloat(this.state.currentMin)) {
      maxVal = parseFloat(this.state.currentMin);
    }

    if(this.props.format == 'currency') {
      maxVal = Math.round(maxVal);
    }

    this.setState({
      currentMax: maxVal,
    }, () => {
      if(this.state.scaleType == 'log') {
        this.setState({ cursorRightPos: this.withinRange(this.logPosFromValue(maxVal), this.state.cursorLeftPos, 1) });
      } else {
        this.setState({ cursorRightPos: this.withinRange(this.linearPosFromValue(maxVal), this.state.cursorLeftPos, 1) });
      }
      


      this.props.refreshData(this.props.service, [this.props.minKey, this.props.maxKey], [this.state.currentMin, this.state.currentMax]);
    });
  }

  withinRange(val, min, max) {
    if(val < min) {
      return min;
    }
    if(val > max) {
      return max;
    }
    return val;
  }

	render() {
		return <div className='NumericSlider' ref={(div) => { this.rootObject = div; }}>
			<div className='sliderWrapper'>
        <div className={'leftBar sliderBar'} style={this.getLeftBarInlineStyles()}></div>
        <div className={'middleBar sliderBar'} style={this.getMiddleBarInlineStyles()}></div>
        <div className={'rightBar sliderBar'} style={this.getRightBarInlineStyles()}></div>
        <div className={'rightBarTail sliderBar'}></div>
        <div className={'leftDot sliderDot'} style={this.getLeftDotInlineStyles()} ref={(div) => { this.leftHandle = div; }}></div>
        <div className={'rightDot sliderDot'} style={this.getRightDotInlineStyles()} ref={(div) => { this.rightHandle = div; }}></div>
      </div>
      <div className='inputWrapper'>
        <div className='dashWrapper'>&mdash;</div>
        <div className='minValWrapper'>
          <input 
            type='number'
            value={this.state.currentMin}
            onChange={::this.changeMinValue}
            onBlur={::this.checkMinValue}
            min={this.props.minValue}
            max={this.state.currentMax}
            step={this.props.increment} />
          {this.props.format == 'currency' ?
            <div className='currencySymbol'>$</div> :
            null
          }
        </div>        
        <div className='maxValWrapper'>
          <input 
            type='number'
            value={this.state.currentMax}
            onChange={::this.changeMaxValue}
            onBlur={::this.checkMaxValue}
            min={this.state.currentMin}
            max={this.props.maxValue}
            step={this.props.increment} />
          {this.props.format == 'currency' ?
            <div className='currencySymbol'>$</div> :
            null
          }
          {this.props.hasPlus && parseFloat(this.state.currentMax) == parseFloat(this.props.maxValue) ?
            <div className='plusOverlay'>+</div> :
            null
          }
        </div>
      </div>
		</div>;
	}
}
export default NumericSlider;

function mapStateToProps(state) {
  return {

  };
}

export const NumericSliderContainer = connect(
  mapStateToProps,
  allActionCreators
)(NumericSlider);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/filterElements/NumericSlider.jsx